module.exports = __webpack_public_path__ + "static/media/icon_180.6962b3b2.svg";